// MODELO E PROVEDOR DE IA SÃO SÓ DO SUPER ADMIN (18/10/2026, decisão do Victor).
//
// "O advogado que contrata o advup não precisa ver qual IA o Lumos usa." Para o escritório, a
// IA é o Lumos e os agentes têm nome próprio. O servidor recusa (Lumos::SoSuperAdmin); aqui a
// tela nem mostra, e a rota manda embora.
import store from 'dashboard/store';

export const ehSuperAdmin = usuario => usuario?.type === 'SuperAdmin';

export const guardaSoSuperAdmin = (to, from, next) => {
  if (ehSuperAdmin(store.getters.getCurrentUser)) {
    next();
    return;
  }
  next({ path: `/app/accounts/${to.params.accountId}/dashboard` });
};
